export default function useWidgetLanguage() {
    const { public: config } = useRuntimeConfig();

    const { locale } = useI18n({
        useScope: 'global',
    });

    const language = computed(() => {
        if (locale.value) {
            const spl = locale.value.split('-');

            return spl[0];
        }

        if (config.i18n.defaultLocale) {
            return config.i18n.defaultLocale;
        }

        return 'de';
    });

    return {
        language,
    };
}
